import isValid from "../date/isValid";
import common from "../common";
import typeOfOperand from "../base/typeOfOperand";
import { WEBUILogs } from "../logging";

export default function isDateInRange(toValidate, options = {}) {
    if (!toValidate || toValidate === "" || common.isEmpty(toValidate)) {
        return true;
    }

    let datesToValidate;
    if (typeOfOperand(toValidate) === "array") {
        datesToValidate = toValidate;
    } else {
        datesToValidate = [toValidate];
    }

    let result = true;

    datesToValidate.forEach(date => {
        let value = new Date(date);
        let range = options.range || {};
        let topDate = new Date(range.top || range.end);
        let bottomDate = new Date(range.bottom || range.start);

        if (!isValid(value)) {
            WEBUILogs.error("isDateInRange: Date validation failed due to illegal date!");
        }

        let isInRange =
            !(isValid(topDate) && value > topDate) && !(isValid(bottomDate) && value < bottomDate);

        if (!isInRange) {
            result = false;
        }
    });

    return result;
}
